import {
  GET_VEHICLE_NUMBER_BY_ID,
  GET_TRACKABLES_BY_FLEET
} from '../query/trackable'
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { split } from 'apollo-link'
import absintheSocketLink from '../graphql/AbsintheSocketLink'
import config from '../config'
import { HttpLink } from 'apollo-link-http'
import { getMainDefinition } from 'apollo-utilities'
import { setContext } from 'apollo-link-context'

const httpLink = new HttpLink({
  uri: config.omega_graphql_api
})

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token')
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    )
  },
  absintheSocketLink,
  authLink.concat(httpLink)
)

const customClient = new ApolloClient({
  link,
  cache: new InMemoryCache()
})

export async function getVehicleNumberByTrackables (trackableIds) {
  var vehicleNumberList = []
  for (var i = 0; i < trackableIds.length; i++) {
    var vehicleNumber = await getVehicleNumberById(trackableIds[i])
    vehicleNumberList.push(vehicleNumber.replace(/\s/g, ''))
  }
  return vehicleNumberList
}

function getVehicleNumberById (trackableId) {
  return new Promise((resolve, reject) => {
    customClient
      .query({
        query: GET_VEHICLE_NUMBER_BY_ID,
        variables: { trackableId: trackableId }
      })
      .then(function (result) {
        resolve(result.data.trackable.licensePlate)
      }).catch(function (err) {
        reject(err)
      })
  })
}

export function resultsToUniqueArray (results) {
  let row = []
  results.forEach(function (element, key) {
    if (element.rows.length > 0) {
      element.rows.forEach(function (value, k) {
        row.push(value)
      })
    }
  })
  return row
}

export function getBody (vehicleNumberList, start, end) {
  let body = {}
  body.queries = []
  vehicleNumberList.forEach(function (element) {
    let bodyContent = {}
    bodyContent.start_key = [
      element,
      start
    ]
    if (end) {
      bodyContent.end_key = [
        element,
        end
      ]
    } else {
      bodyContent.end_key = [
        element,
        {}
      ]
    }
    body.queries.push(bodyContent)
  })
  return body
}

export function getFleetById (fleetId) {
  return new Promise((resolve, reject) => {
    customClient
      .query({
        query: GET_TRACKABLES_BY_FLEET,
        variables: { fleetId: fleetId.toUpperCase() }
      })
      .then(function (result) {
        resolve(result.data.fleet)
      }).catch(function (err) {
        reject(err)
      })
  })
}

export function getTrackableIds (trackables) {
  var trackableIds = []
  for (var trackable of trackables) {
    trackableIds.push(trackable.id)
  }
  return trackableIds
}

export function getSensorIds (trackables) {
  var sensorIds = []
  for (var trackable of trackables) {
    sensorIds.push(trackable.label)
  }
  return sensorIds
}
